import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
    loading: true,
    plansList: [],
    plansLookup: [],
    plan: null,
    success: false,
}

export const planSlice = createSlice({
    name: 'plans',
    initialState,
    reducers: {
        getPlansList: (state, action) => {
            state.loading = true
        },
        plansSuccess: (state, action) => {
            state.plansList = action.payload
            state.loading = false
        },
        plansFailed: (state, action) => {
            state.loading = false
        },
        getPlansLookup: (state, action) => {
            state.loading = true
        },
        plansLookupSuccess: (state, action) => {
            state.plansLookup = action.payload
            state.loading = false
        },
        plansLookupFailed: (state, action) => {
            state.loading = false
        },
        getPlan: (state, action) => {
            state.loading = true
        },
        planSuccess: (state, action) => {
            state.plan = action.payload
            state.loading = false
        },
        planFailed: (state, action) => {
            state.loading = false
            state.plan = null
        },
        createNewPlan: (state, action) => {},
        updatePlan: (state, action) => {},
        planCreatedUpdated: (state, action) => {
            state.success = true
        },
        planCreationFailed: (state, action) => {},
        updatePlanStatus: (state, action) => {},
        planStatusUpdateSuccess: (state, action) => {},
        planStatusUpdateFailed: (state, action) => {},
        deletePlan: (state, action) => {},
        planDeletedSuccessfully: (state, action) => {
            state.plansList = state.plansList.filter((c) => c.id !== action.payload.id)
        },
        planDeletionFailed: (state, action) => {},
        resetPlan: (state, action) => {
            state.loading = false
            state.plan = null
            state.success = false
        }
    }
})

export const {
    getPlansList,
    plansSuccess,
    plansFailed,
    getPlan,
    planSuccess,
    planFailed,
    resetPlan,
    updatePlanStatus,
    planStatusUpdateSuccess,
    planStatusUpdateFailed,
    createNewPlan,
    updatePlan,
    planCreatedUpdated,
    planCreationFailed,
    deletePlan,
    planDeletedSuccessfully,
    planDeletionFailed,

    getPlansLookup,
    plansLookupSuccess,
    plansLookupFailed,
} = planSlice.actions;

export default planSlice.reducer;
